/**
 * @fileoverview Implementación del cliente de CR Auth con su propia instancia de axios.
 * No usa la instancia global: su interceptor agrega `origen` al body (CR Auth lo rechaza con 400)
 * y maneja el `codigoRespuesta` '99' de ZS Backend.
 * @module integrations/impl/auth.integration.impl
 */

import axios from 'axios'
import environment, { APPLICATION_ID } from '../../utils/environment'
import { toIntegrationError, logIntegrationError } from './integration-error'

const TIMEOUT_MS = 30000
const INTEGRATION_NAME = 'CR Auth'

/**
 * Crea el cliente HTTP de CR Auth.
 * @returns {Object} Instancia de axios
 */
export function createAuthHttpClient () {
  return axios.create({
    baseURL: environment.getAuthApiUrl(),
    timeout: TIMEOUT_MS,
    headers: {
      'Content-Type': 'application/json',
      'Application-ID': APPLICATION_ID
    }
  })
}

/**
 * Crea la implementación del contrato AuthIntegration.
 * @param {Object} [http] - Instancia de axios (inyectable en tests)
 * @returns {import('../auth.integration').AuthIntegration}
 */
export function createAuthIntegration (http = createAuthHttpClient()) {
  const post = (operation, path, body, config) => http.post(path, body, config)
    .then(res => res.data)
    .catch(error => {
      const integrationError = toIntegrationError(error)
      logIntegrationError(INTEGRATION_NAME, operation, integrationError)
      throw integrationError
    })

  return {
    login: request => post('login', 'auth/login', request),
    signup: request => post('signup', 'auth/signup', request),
    passwordRecovery: request => post('passwordRecovery', 'auth/password/recovery', request),
    otpResend: request => post('otpResend', 'auth/otp/resend', request),
    otpVerify: request => post('otpVerify', 'auth/otp/verify', request),
    refresh: refreshToken => post('refresh', 'auth/token/refresh', { refreshToken }),
    logout: accessToken => post('logout', 'auth/logout', null, {
      headers: { Authorization: `Bearer ${accessToken}` }
    }).then(() => undefined)
  }
}



// WEBPACK FOOTER //
// ./src/integrations/impl/auth.integration.impl.js